// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"318":"mggp-desktop-skin","426":"mggp-skin"}[chunkId] + "." + {"318":"1a057dd8","426":"66434b3a"}[chunkId] + ".chunk.css";
};